import { GameId } from '@bg-shared/enums/GameId';
import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature';
import { ICasinoValidationError, ICasinoValidationModel } from '../interfaces';
import { ChipValidationState } from '../enums';

export const casinoValidationEntity = new StoresEntity(
    class CasinoValidation extends Store<ICasinoValidationModel> {
        // key -> "optionItemID" generated with "optionIDConverter"
        constructor(gameId: GameId) {
            super({
                key: `CasinoValidation/${gameId}`,
                default: {},
            });
        }

        public setErrors(errors: Record<string, ICasinoValidationError>) {
            this.update((draft) => {
                Object.entries(errors).forEach(([optionItemID, error]) => {
                    draft[optionItemID] = {
                        message: error.message,
                        state: ChipValidationState.ERROR,
                    };
                });
            });
        }

        public setHighlight(optionItemIDs: string[]): void {
            this.update((draft) => {
                optionItemIDs.forEach((id) => {
                    draft[id] = {
                        state: ChipValidationState.HIGHLIGHTED,
                    };
                });
            });
        }
    },
);
